import { fetchWithToken } from "../../helpers/fetch";
import { types } from "../../types/types";

export const getDownloadXmlSatStatistics = (preReportId) => {
  return async (dispatch) => {
    const resp = await fetchWithToken(
      `api/DownloadXmlSAT/DownloadStatistics/${preReportId}`,
      null,
      "POST"
    );
    const body = await resp.json();

    if (body.success) {
      dispatch(getDownloadXmlSatStatisticsRegister(body.data));
    }
  };
};

export const getDownloadXmlSatStatisticsRegister = (infoReport) => ({
  type: types.downloadXmlSatStatistics,
  payload: infoReport,
});
